export default __webpack_public_path__ + "static/media/logo.580c2906.png";